import { BaseService } from './base.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ResultApi } from '../viewModel/result_api.model';
import { ValidaEmail } from '../viewModel/valida_email.model';

@Injectable({
    providedIn: 'root'
})
export class AssociadoService extends BaseService {

    constructor(private httpClient: HttpClient) {
        super(httpClient, 'associado');
    }

    public async cadastraDadosPessoais(data: any): Promise<any> {
        try {
            const httpOptions = await this.getHttpOptions();
            return this.httpClient
                .post<any>(`${this.path()}/cadastroDadosPessoaiss`, data, httpOptions)
                .toPromise()
                .then((res: any) => this.response(res, 200))
                .catch((err: any) => err);
        } catch (e) {
            return null;
        }
    }

    public async validarExisteEmail(data: any): Promise<ResultApi> {
        try {
            const httpOptions = await this.getHttpOptions();
            return this.httpClient
                .get<ValidaEmail>(`${this.path()}/validarExisteEmail?email=${data}`, httpOptions)
                .toPromise()
                .then((res: any) => this.response(res, 200))
                .catch((err: any) => err);
        } catch (e) {
            return null;
        }
    }

    public async validarExisteCpf(data: any): Promise<ResultApi> {
        try {
            const httpOptions = await this.getHttpOptions();
            return this.httpClient
                .get<ValidaEmail>(`${this.path()}/validarExisteCPF?cpf=${data}`, httpOptions)
                .toPromise()
                .then((res: any) => this.response(res, 200))
                .catch((err: any) => err);
        } catch (e) {
            return null;
        }
    }

    public async salvaNome(nome: string): Promise<ResultApi> {
        try {
            const httpOptions = await this.getHttpOptions();
            return this.httpClient
                .get<ValidaEmail>(`${this.path()}/salvaNome?nome=${nome}`, httpOptions)
                .toPromise()
                .then((res: any) => this.response(res, 200))
                .catch((err: any) => err);
        } catch (e) {
            return null;
        }
    }
}
